import { useEffect, useState } from 'react'
import type { WidgetProps } from '@rjsf/utils'
import { Mtds, DateInputWidget } from 'prove-common'

type AgeWidgetProps = WidgetProps & {
  value: number | null
  onChange: (value: number | null | undefined) => void
}

export const AgeWidget = ({
  className,
  disabled,
  id,
  onChange,
  placeholder,
  readonly,
  required,
  value
}: AgeWidgetProps) => {
  const [age, setAge] = useState<number | null>(value)
  const [unit, setUnit] = useState('days')
  const [date, setDate] = useState(new Date().toISOString().split('T')[0])
  const dateDiff = new Date(Date.now()).getTime() - new Date(date).getTime()
  const dateDiffDays = Math.floor(dateDiff / 1000 / 60 / 60 / 24)

  useEffect(() => {
    if (value === undefined && age === null) return
    if (value == null) {
      setAge(null)
      setUnit('days')
      setDate(new Date().toISOString().split('T')[0])
    } else if (age == null) {
      setAge(value)
    }
  }, [value])

  useEffect(() => {
    if (unit === 'datepicker') onChange(dateDiffDays)
    else if (Number.isNaN(age) || age === null) onChange(undefined)
    else if (unit === 'months') onChange(age ? age * 30 : null)
    else if (unit === 'days') onChange(age)
  }, [age, unit, date])

  return (
    <Mtds.Grid>
      <div className={'flex flex-row gap-2 break-normal'}>
        {unit === 'datepicker' ? (
          <DateInputWidget
            className={`${className} flex-1`}
            disabled={disabled}
            id={id}
            onChange={setDate}
            placeholder={placeholder}
            readonly={readonly}
            required={required}
            value={date}
          />
        ) : (
          <Mtds.Input
            aria-labelledby={`${id}_label`}
            className={`${className} flex-1`}
            disabled={disabled}
            id={id}
            min={0}
            onChange={({ target }) =>
              setAge(target.value === '' ? null : Number(target.value))
            }
            placeholder={placeholder}
            readOnly={readonly}
            required={required}
            type='number'
            value={age ?? ''}
          />
        )}
        <Mtds.Field
          as='select'
          className={'flex-1'}
          disabled={disabled}
          onChange={({ target }) => setUnit(target.value)}
          value={unit}
          options={[
            { value: 'days', label: 'dager' },
            { value: 'months', label: 'måneder' },
            { value: 'datepicker', label: 'fødseldato' }
          ]}
        />
      </div>
      {unit === 'datepicker' && (
        <Mtds.Group as={Mtds.Flex} data-justify='space-between'>
          <Mtds.Muted>Antall dager</Mtds.Muted>
          <strong>{Math.floor(dateDiffDays)}</strong>
        </Mtds.Group>
      )}
    </Mtds.Grid>
  )
}
